import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Navbar() {
  const { user, logout } = useAuth();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('login'); // 'login' or 'register'

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      const endpoint = mode === 'register' ? '/auth/register' : '/auth/login';
      const res = await api.post(endpoint, { email });
      setMessage(res.data.message);
      setEmail('');
    } catch (err) {
      setMessage(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <nav style={styles.nav}>
      <div style={styles.brand}>
        🎓 AlcatelUnleashed
      </div>

      <div style={styles.right}>
        {user ? (
          <div style={styles.userArea}>
            <span style={styles.credits}>
              ✏️ {user.post_credits} posts &nbsp;|&nbsp; 👍 {user.vote_credits} votes
            </span>
            <span style={styles.email}>{user.email}</span>
            <button onClick={logout} style={styles.logoutBtn}>Log out</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={styles.form}>
            <select
              value={mode}
              onChange={e => setMode(e.target.value)}
              style={styles.select}
            >
              <option value="login">Log in</option>
              <option value="register">Register</option>
            </select>
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={styles.input}
            />
            <button type="submit" disabled={loading} style={styles.btn}>
              {loading ? '...' : mode === 'register' ? 'Register' : 'Log in'}
            </button>
            {message && <span style={styles.message}>{message}</span>}
          </form>
        )}
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 32px',
    height: '64px',
    background: '#ffffff',
    borderBottom: '1px solid #e5e7eb',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  brand: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#111827',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  form: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  select: {
    padding: '8px 12px',
    borderRadius: '6px',
    border: '1px solid #d1d5db',
    fontSize: '14px',
    color: '#374151',
    background: '#f9fafb',
    cursor: 'pointer',
  },
  input: {
    padding: '8px 12px',
    borderRadius: '6px',
    border: '1px solid #d1d5db',
    fontSize: '14px',
    width: '220px',
    outline: 'none',
  },
  btn: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: 'none',
    background: '#2563eb',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  logoutBtn: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: '1px solid #d1d5db',
    background: '#ffffff',
    color: '#374151',
    fontSize: '14px',
    cursor: 'pointer',
  },
  userArea: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  credits: {
    fontSize: '13px',
    color: '#6b7280',
    background: '#f3f4f6',
    padding: '6px 12px',
    borderRadius: '20px',
  },
  email: {
    fontSize: '14px',
    color: '#374151',
  },
  message: {
    fontSize: '13px',
    color: '#2563eb',
    marginLeft: '8px',
  },
};